// extracted by mini-css-extract-plugin
export default {"form":"EventForm_form__ODMis","actions":"EventForm_actions__7GxxD"};